import React from 'react';

import Row from 'react-bootstrap/Row';

import Result from './Result';

import { SearchResult } from '../api/services/search/interfaces';

interface Props {
  results: SearchResult[];
}

const Results: React.FC<Props> = ({ results }: Props) => {
  return (
    <Row className={'search-results'}>
      {results.map((result) => (
        <Result result={result} key={result.url} />
      ))}
    </Row>
  );
};

export default Results;
